import React, { useEffect, useState } from 'react'
import HeaderCustomerPreview from '../../layout/header/HeaderCustomerPreview'
import Loader from '../../components/Loader'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import SnackbarAlert from '../../shared-components/snackbar-alert/SnackbarAlert'
import CompanyDetails from './components/CompanyDetails'
import AuthorisedSignatoryDetails from './components/AuthorisedSignatoryDetails'
import UnitDetails from './components/UnitDetails'
import CompanyDocuments from './components/CompanyDocuments'
import SignaturePopup from '../../shared-components/signature-popup/SignaturePopup'
import { route } from '../../services/apiRoutes'
import { useHistory, useParams } from 'react-router-dom'
import { BOOKING_FORM_STATUS, ERROR_MESSAGE, BOOKING_AS } from '../../config/constant'
import caretUp from "../../assets/icons/caret-up.svg"
import TermsAndConditionPreview from './components/TermsAndConditionPreview'
import TermsAndConditionOfflinePreview from './components/TermsAndConditionOfflinePreview'
import { getApplicantDetails, getBookingDocuments, getOppprtunityDetails, setActiveStep, setESignature, setOffline, setResetData, updateReviewAndSign } from '../new-booking-form/new-booking-form.slice'
import TermsAndCondition from '../new-booking-form/components/terms-and-condition/TermsAndCondition'
import { useTranslation } from 'react-i18next'
import KYCDocuments from './components/KYCDocuments'
import PaymentDetails from './components/PaymentDetails'
import { ReferrerDetails } from './components/ReferrerDetails'
import { useHandleRedirection } from '../new-booking-form/hooks/useHandleRedirection'

const EntityBasedPreview = () => {
  const { t } = useTranslation("common");
  const { oppId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [openSignatureModal, setOpenSignatureModal] = useState(false);
  const {
    isLoading,
    applicantData,
    enquiryDetails,
    eSignature,
    offline,
    bookingDocuments,
    applicantEditPreview,
  } = useSelector((state) => state?.newBookingForm);

  const isEntityBooking = applicantData?.bookingAs === BOOKING_AS.CORPORATE || applicantData?.bookingAs === BOOKING_AS.PARTNERSHIP_FIRM; 

  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const { handleRedirection } = useHandleRedirection();
  
  useEffect(() => {
    if (applicantData?.opportunityId !== oppId) {
      dispatch(setResetData());
    }
  }, []);

  useEffect(() => {
    dispatch(getOppprtunityDetails(`/${oppId}`));
    //dispatch(getApplicantDetails(`/${oppId}`));
    dispatch(getBookingDocuments(`/${oppId}`))
    window.scrollTo(0, 0);
  }, [dispatch, oppId]);

  useEffect(() => {
    if (applicantData?.isCompleted) {
      setStep2(true);
      setStep1(false);
    } else {
      setStep1(true);
      setStep2(false);
    }
  }, [applicantData?.isCompleted]);

  useEffect(() => {
    if (oppId?.length > 0) {
      dispatch(getApplicantDetails(`/${oppId}`))
        .unwrap()
        .then((res) => {
          if (res) {
            handleRedirection(
              res, ""
            )
          }
          if (res?.signedPdf !== null) {
            dispatch(setActiveStep(null));
          }
        })
        .catch((error) => {
          dispatch(setResetData());
          if (!error?.message?.includes("Booking with Opportunity")) {
            setSnackBarconfig({
              open: true,
              message: ERROR_MESSAGE,
              severity: "error",
            });
          }
          console.log('error', error)
          history.push(`/booking-form/${oppId}`)
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleRedirection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData?.bookingFormStatus, step2, eSignature])

  useEffect(() => {
    if (applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.SIGNED_OFFLINE) {
      dispatch(setOffline(true));
    } else {
      dispatch(setOffline(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData?.bookingFormStatus]);

  useEffect(() => {
    if (applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.PARTIALLY_SIGNED || applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.NOT_SIGNED) {
      dispatch(setESignature(true));
    } else {
      dispatch(setESignature(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData?.bookingFormStatus]);

  const handleESignature = () => {
    let payload = {
      opportunityId: oppId,
      isSignedOffline: false,
      isCompleted: true,
    };
    dispatch(
      updateReviewAndSign({
        path: route.UPDATE_SUBMIT_FOR_SIGNATURE,
        payload: payload,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.status === 200 || res?.status === 201) {
          setStep1(false);
          setOpenSignatureModal(false)
          setStep2(true);
          handleRedirection()
        } else {
          setSnackBarconfig({
            open: true,
            message: ERROR_MESSAGE,
            severity: "error",
          });
        }
      })
  }

  const handleOffline = () => {
    let payload = {
      opportunityId: oppId,
      isSignedOffline: true,
      isCompleted: true,
    };
    dispatch(
      updateReviewAndSign({
        path: route.UPDATE_SUBMIT_FOR_SIGNATURE,
        payload: payload,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.status === 200 || res?.status === 201) {
          setStep1(false);
          setOpenSignatureModal(false)
          setStep2(true);
          setOpenSignatureModal(false)
          handleRedirection()
        } else {
          setSnackBarconfig({
            open: true,
            message: ERROR_MESSAGE,
            severity: "error",
          });
        }
      })
  }

  const handleScrollToSignature = () => {
    const signatureSection = document.getElementById("signature");
    if (signatureSection) {
      signatureSection.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }
  }

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleSignatureModal = () => {
    setOpenSignatureModal(prev => !prev);
  }

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <HeaderCustomerPreview />

      {/* <Header /> */}
      {applicantData !== null ? (
        <div className="CustomerPreviewWrapper">
          <Box
            sx={{
              fontSize: "22px",
              fontWeight: "500",
              textAlign: 'center',
              color: '#1A407D',
              marginBottom: {
                xs: '20px',
                sm: '0px',
              },
              display: {
                xs: 'block',
                sm: 'none',


              },
            }}
          >
            {t("preview.title")}
          </Box>
          {isEntityBooking && <CompanyDetails applicantData={applicantData} />}
          <AuthorisedSignatoryDetails applicantData={applicantData} isEntityBooking={isEntityBooking} />
          {<UnitDetails applicantData={applicantData}  bookingDocuments={bookingDocuments}/>}
          <PaymentDetails applicantData={applicantData} />
          {isEntityBooking &&  <CompanyDocuments applicantData={applicantData}/>}
  
          <KYCDocuments applicantData={applicantData} isEntityBooking={isEntityBooking}/>
          {applicantData?.referrerDetails !== null && (
            <ReferrerDetails applicantData={applicantData} enquiryDetails={enquiryDetails} />
          )}
          <TermsAndCondition isPreview={true} enquiryDetails={enquiryDetails} />
          {step1 === true && (
            <div className="applicantDetailsCard">
              <div className="submit-button"
                onClick={handleSignatureModal}
              >
                {t("button.submit")}
              </div>
            </div>
          )}

          {step2 === true && (
            <>
              {eSignature && (
                <TermsAndConditionPreview applicantData={applicantData} />
              )}
              {offline && (
                <TermsAndConditionOfflinePreview />
              )}
              <button className="scroll-to-signature" onClick={handleScrollToSignature}>
                <img src={caretUp} alt="" />
              </button>
            </>
          )}

          {openSignatureModal && (
            <SignaturePopup
              closePopup={handleSignatureModal}
              handleESignature={handleESignature}
              handleOffline={handleOffline}
            />
          )}

          <SnackbarAlert
            open={snackbarConfig.open}
            message={snackbarConfig.message}
            severity={snackbarConfig.severity}
            onClose={handleSnackbarClose}
          />
        </div>
      ) : null}
    </>
  )
}

export default EntityBasedPreview